import formatDate from "@utils/formatDate"

export function formatSingleDate(date: Date): string {
    return formatDate({
        datetime: date,
        addYear: date.getFullYear() !== new Date().getFullYear(),
    }).localDateString
}
